var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:_vm.customClass},_vm.$listeners),[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":""}}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }